import classNames from 'classnames';
import c from './units-field.module.scss';
import cs from '../application-details.module.scss';
import { Dropdown, fontStyles } from '@monash/portal-react';
import { Controller } from 'react-hook-form';
import { useContext } from 'react';
import { DataContext } from '@/components/providers/data-provider/DataProvider';

const UnitsField = () => {
  const { enrolledUnits } = useContext(DataContext);

  return (
    <div className={cs.fieldWrapper}>
      <div
        className={classNames(
          fontStyles.heading,
          fontStyles.sm,
          fontStyles.medium
        )}
      >
        Which PASS unit(s) are you interested in?
        <span className={cs.required}>*</span>
      </div>
      <div className={classNames(fontStyles.label, c.label)}>
        Select all units where you would like to provide peer-assisted study
        support. You can select multiple options.
      </div>
      <Controller
        name="units"
        rules={{
          validate: (value) => value?.length >= 1 || 'Select at least one unit',
        }}
        render={({ field: { value, onChange, onBlur } }) => (
          <Dropdown
            data={enrolledUnits.map((unit) => ({
              text: unit.unitCode,
              value: unit.unitOfferingId,
            }))}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            multi
          />
        )}
      />
    </div>
  );
};

export default UnitsField;
